export class StarterWidgetPropertyController {
	constructor($scope, eventSender, $element) {
		this.$scope = $scope;
		this.eventSender = eventSender;
		this.$element = $element;
		console.log('StarterWidgetPropertyController constructor');
		this.tabId;
		this.widget;
		this.closeCallback;
		this.query;
		this.interval;
		this.name;
		this.$scope.seconds = false;
		this.$scope.$on('StarterWidgetPropertyController:openPropertyModal', this.init.bind(this));
	}

	init(e, widget, tabId, closeCallback){
		this.widget = widget;
		this.tabId = tabId;
		this.closeCallback = closeCallback;
		this.query = this.widget.ctx.data.query;
		this.interval = this.widget.ctx.interval;
		this.name = this.widget.ctx.name;
		this.$scope.$apply();
	}

	updateWidgetProperty() {
		if(!!this.closeCallback){
			this.closeCallback({
				interval: this.interval
			});
		}

		this.$scope.cancelUpdateWidgetProperty();
	}

	cancelUpdateWidgetProperty() {
		this.$element[0].hideDialog();
	}

	changeNumberString() {
		if(this.$scope.interval > 1)
			return true;
	}
}

StarterWidgetPropertyController.$inject = ['$scope', 'eventSender', '$element'];


// WEBPACK FOOTER //
// ./resources/WEB-INF/package/system/starter/StarterWidgetPropertyController.js